/* 热门品牌栏 */
import React from 'react'
import Link from 'next/link'

import { sendTeaCommEvent } from 'lib/tea-analyze'
import { IBrands } from './interface'
import applyHttpsImage from 'lib/apply-https-img'
import { get } from 'lodash'

interface IProps {
  brands: IBrands[]
}

export default function PopularBrands({ brands }: IProps) {
  /* 渲染热门品牌 */
  const hotBrandIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  const showBrands: IBrands[] = []
  brands &&
    brands.forEach(brand => {
      const brandId = get(brand, 'info.brand_id')
      if (hotBrandIds.indexOf(brandId) >= 0) {
        // 热门品牌集合
        showBrands.push({
          brand_id: brandId,
          image_url: get(brand, 'info.image_url', '').replace('http:', ''),
          brand_name: get(brand, 'info.brand_name', ''),
        })
      }
    })

  function renderBrands() {
    const list = [[...showBrands.slice(0, 5)], [...showBrands.slice(5, 10)]]
    return (
      <div className="brands">
        {list.map((brand: IBrands[], index: number) => {
          return (
            <div className="list" key={index}>
              {brand.map((item: IBrands) => (
                <Link
                  key={item.brand_name}
                  href={`/auto/library/x-x-x-x-x-x-x-x-x-x-x?key=brand&param=${item.brand_id}&text=${item.brand_name}`}
                  as={`/auto/library/x-x-x-x-x-x-x-x-x-x-x?key=brand&param=${item.brand_id}&text=${item.brand_name}`}
                >
                  <a
                    target="_blank"
                    className="box"
                    onClick={() => {
                      sendTeaCommEvent('click_home_brand_selector', item)
                    }}
                  >
                    <span
                      className="photo"
                      style={{
                        backgroundImage: `url(${applyHttpsImage(
                          item.image_url
                        )})`,
                      }}
                    />
                    <span>{item.brand_name}</span>
                  </a>
                </Link>
              ))}
            </div>
          )
        })}
        <style jsx>
          {`
            .list {
              padding: 24px 16px 0 16px;
              display: flex;
              justify-content: space-between;
            }
            .list:last-child {
              padding-bottom: 24px;
              border-bottom: 0;
            }
            .box {
              display: inline-block;
              text-align: center;
              cursor: pointer;
            }
            .box:last-child {
              margin-right: 0;
            }
            .photo {
              display: block;
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background-size: 40px 40px;
              margin-bottom: 2px;
            }
          `}
        </style>
      </div>
    )
  }

  return (
    <div className="brands fl">
      <header className="header">
        <h2 className="title">热门品牌</h2>
        <Link
          href="/auto/library/x-x-x-x-x-x-x-x-x-x-x"
          as="/auto/library/x-x-x-x-x-x-x-x-x-x-x"
        >
          <a
            onClick={() => {
              sendTeaCommEvent('click_home_brand_selector_more')
            }}
            target="_blank"
            className="icon"
          >
            更多品牌
            <span className="icon-arrow-ic-r arrow" />
          </a>
        </Link>
      </header>
      {renderBrands()}
      <div className="download">
        <div className="tip" />
        <div className="download-link">
          <a
            onClick={() => {
              sendTeaCommEvent('click_top_download_ios')
            }}
            target="_blank"
            rel="noopener noreferrer"
            href="https://apps.apple.com/cn/app/懂车帝-帮你买车用车的车友之家/id1232131998"
            className="ios-download"
          />
          <span className="divide-line" />
          <a
            onClick={() => {
              sendTeaCommEvent('click_top_download_apk')
            }}
            target="_blank"
            rel="noopener noreferrer"
            href="https://d.toutiao.com/jLdp/"
            className="apk-download"
          />
        </div>
        <div className="qrcode-tip">
          <span className="qrcode-icon" />
          <div className="qrcode-container">
            <div className="box">
              <h3>扫码下载懂车帝APP</h3>
              <img
                src={require('static/dcd-code@3x.png')}
                alt=""
                className="qrcode"
              />
            </div>
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .brands {
            width: 380px;
            min-height: 215px;
            font-size: 16px;
            border-top: 0;
            border-left: 0;
            margin-left: 16px;
          }
          .header {
            height: 36px;
            line-height: 36px;
            box-sizing: content-box;
          }
          .title {
            display: inline;
            font-size: 24px;
            font-weight: 500;
          }
          .icon {
            float: right;
          }
          .arrow {
            display: inline-block;
            color: #000;
            font-size: 16px;
            margin-top: -3px;
            margin-left: 4px;
            vertical-align: middle;
          }
          .download {
            width: 380px;
            height: 48px;
            position: relative;
            display: flex;
          }
          .tip {
            position: absolute;
            width: 86px;
            height: 56px;
            left: 0;
            bottom: 0;
            background-image:url('${require('static/downLoad/download-tip.png')}');
            background-size: cover;
          }
          .download-link {
            display: flex;
            flex: 1;
            padding: 0 12px 0 98px;
            align-items: center;
            justify-content: space-between;
            border-radius: 2px;
            background: #1f2129;
            background-image: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0.6),
              rgba(0, 0, 0, 0)
            );
          }
          .divide-line {
            width: 1px;
            height: 16px;
            background: #606370;
          }
          .ios-download,.apk-download {
            height: 30px;
            background-size: cover; 
          }
          .ios-download {
            width: 100px;
            background-image:url('${require('static/downLoad/apple-store.png')}');
          }
          .ios-download:hover {
            background-image: url('${require('static/downLoad/apple-store-hover.png')}')
          }
          .apk-download {
            width: 92px;
            background-image: url('${require('static/downLoad/apk.png')}');
          }
          .apk-download:hover {
            background-image: url('${require('static/downLoad/apk-hover.png')}');
          }
          .qrcode-tip {
            cursor: pointer;
            postion: relative;
            margin-left: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            border-radius: 2px;
            background: #1f2129;
            background-image: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0.6),
              rgba(0, 0, 0, 0)
            );
          }
          .qrcode-icon {
            width: 24px;
            height: 24px;
            background: url('${require('static/downLoad/code.png')}');
            background-size: cover;
          }
          .qrcode-tip:hover .qrcode-icon {
            background: url('${require('static/downLoad/code-hover.png')}');
            background-size: cover;
          }

          .qrcode-tip:hover .qrcode-container {
            display: block;
          }

          .qrcode-container {
            display: none;
            width: 200px;
            background: transparent;
            position: absolute;
            top: 48px;
            right: 0;
            z-index: 199;
            padding-top: 8px;
          }
          .box {
            width: 200px;
            height: 236px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.2);
            text-align: center;
            background: #ffffff;
            padding: 16px 0 20px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .box h3 {
            font-size: 14px;
            font-weight: normal;
            line-height: 20px;
            color: #1f2129;
            margin-bottom: 20px;
          } 
          .qrcode {
            width: 160px;
            height: 160px;
          }
        `}
      </style>
    </div>
  )
}
